import { type DomainAccessControlConfig } from '../../../utils/domain/accessControl'
import { Permission } from '../../../access-control/permissions'
import { FeatureToggle } from '../../../access-control/featureToggles'

export const caperBillingAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.rtIppCaperBillingEnabled],
    permissions: [Permission.CaperBillingView],
  },
]
